module.exports = __webpack_public_path__ + "img/tiger-footprint.64692661.svg";